import React from 'react';
import Icon from '../../../components/AppIcon';

const CollectibleTypeSelector = ({ selectedTypes, onTypeToggle }) => {
  const collectibleTypes = [
    {
      id: 'watches',
      name: 'Luxury Watches',
      icon: 'Watch',
      description: 'Rolex, Patek Philippe, Audemars Piguet',
      color: 'from-blue-500 to-blue-600',
      popular: true
    },
    {
      id: 'art',
      name: 'Fine Art',
      icon: 'Palette',
      description: 'Paintings, sculptures, limited editions',
      color: 'from-purple-500 to-purple-600',
      popular: true
    },
    {
      id: 'coins',
      name: 'Rare Coins',
      icon: 'Coins',
      description: 'Historical coins, precious metals',
      color: 'from-yellow-500 to-yellow-600',
      popular: false
    },
    {
      id: 'cards',
      name: 'Trading Cards',
      icon: 'CreditCard',
      description: 'Sports cards, Pokemon, Magic: The Gathering',
      color: 'from-green-500 to-green-600',
      popular: true
    },
    {
      id: 'jewelry',
      name: 'Fine Jewelry',
      icon: 'Gem',
      description: 'Diamonds, precious stones, vintage pieces',
      color: 'from-pink-500 to-pink-600',
      popular: false
    },
    {
      id: 'wine',
      name: 'Vintage Wine',
      icon: 'Wine',
      description: 'Rare vintages, investment-grade bottles',
      color: 'from-red-500 to-red-600',
      popular: false
    },
    {
      id: 'books',
      name: 'Rare Books',
      icon: 'Book',
      description: 'First editions, manuscripts, signed copies',
      color: 'from-amber-500 to-amber-600',
      popular: false
    },
    {
      id: 'cars',
      name: 'Classic Cars',
      icon: 'Car',
      description: 'Vintage automobiles, supercars',
      color: 'from-gray-500 to-gray-600',
      popular: false
    }
  ];

  const isSelected = (typeId) => selectedTypes?.includes(typeId);

  return (
    <div className="space-y-4">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-foreground mb-2">
          What do you collect?
        </h3>
        <p className="text-sm text-muted-foreground">
          Select your areas of interest to personalize your experience
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {collectibleTypes?.map((type) => (
          <button
            key={type?.id}
            onClick={() => onTypeToggle(type?.id)}
            className={`relative p-4 rounded-lg border-2 transition-all duration-300 premium-hover text-left ${
              isSelected(type?.id)
                ? 'border-primary bg-primary/10 shadow-gold'
                : 'border-border bg-card hover:border-primary/50 hover:bg-primary/5'
            }`}
          >
            {type?.popular && (
              <div className="absolute -top-2 -right-2 bg-conversion-accent text-white text-xs px-2 py-1 rounded-full font-medium">
                Popular
              </div>
            )}
            
            <div className="flex items-start space-x-3">
              <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${type?.color} flex items-center justify-center flex-shrink-0`}>
                <Icon name={type?.icon} size={20} color="white" />
              </div>
              
              <div className="flex-1 min-w-0">
                <h4 className={`font-medium mb-1 ${
                  isSelected(type?.id) ? 'text-primary' : 'text-foreground'
                }`}>
                  {type?.name}
                </h4>
                <p className="text-xs text-muted-foreground line-clamp-2">
                  {type?.description}
                </p>
              </div>

              {isSelected(type?.id) && (
                <div className="flex-shrink-0">
                  <div className="w-5 h-5 bg-primary rounded-full flex items-center justify-center">
                    <Icon name="Check" size={12} color="#1A1B23" />
                  </div>
                </div>
              )}
            </div>
          </button>
        ))}
      </div>
      <div className="text-center">
        <p className="text-xs text-muted-foreground">
          You can always add more categories later in your profile settings
        </p>
      </div>
    </div>
  );
};

export default CollectibleTypeSelector;